<template>
  <div class="entire-item-dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="450px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" :rules="rules" size="small" ref="form" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('crm_ship_receipCode_dialog.shou_huo_ren')" prop="consigneeName">
                <el-input v-model="form.consigneeName"  style="100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('crm_ship_receipCode_dialog.dian_hua_hao_ma')" prop="consigneePhone">
                <el-input v-model="form.consigneePhone"  style="100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      ossConfig: {},
      item: {},
      // visible: false,
      fileList: [],
      form: {
        consigneeName: '',
        consigneePhone: '',
        customShipmentNum: ''
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        consigneeName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        consigneePhone: [
          { required: true, message: this.$t('crm_ship_receipCode_dialog.qsrdhhm') },
          { validator: null, message: this.$t('crm_ship_receipCode_dialog.cdyz713gzf') },
        ],

      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.form.customShipmentNum = this.model.data.customShipmentNum;
      this.form.consigneeName = this.model.data.consigneeName;
      this.form.consigneePhone = this.model.data.consigneePhone;
      this.$nextTick(() => {
        // this.visible = true;
      });
      this.formRule();
    },
    formRule: function () {
      this.rules.consigneePhone[1].validator = this.$mobilePhoneValidator;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        this.saveUpdate();

      });
    },

    // 保存编辑
    saveUpdate: function () {
      this.$postJSON(apis.shipPlanSmsSendCode, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.closeDialog();
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss">
.entire-item-dialog {
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .left {
    border-right: 1px solid #eef2f8;
    padding-right: 24px;
  }
  .right {
    padding-left: 24px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }
}
</style>
